import { render } from "./ProjectsLoseList.vue?vue&type=template&id=f2b9e33e"
import script from "./ProjectsLoseList.vue?vue&type=script&lang=js"
export * from "./ProjectsLoseList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__